import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useConfiguratorContext } from "../../../../../../../../Context/Context/ConfiguratorContext.js";
import { useSteps } from "../../../../../../../../hooks/hooks/use-steps.js";
import { SecondaryAction } from "./SecondaryAction.js";
function SecondaryActionContainer() {
  const { getLabel } = useIntl();
  const { configuratorId, goToPreviousStep, onModalClose, onTriggerDataLayer } = useConfiguratorContext();
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const { steps, currentStepIndex } = useSteps();
  const isFirstStep = currentStepIndex === 0;
  const previousSteps = steps.slice(0, currentStepIndex);
  const allPreviousStepsSkipped = previousSteps.every((s) => s.skip);
  const shouldBeClosed = isFirstStep || allPreviousStepsSkipped;
  const handleSecondaryAction = React.useCallback(() => {
    onTriggerDataLayer({
      steps,
      currentStepIndex,
      eventType: shouldBeClosed ? "rx_close_click" : "rx_previous_step_click",
      eventCategory: configuratorId === "rxSun" ? "rx_sunglasses" : "rx_glasses"
    });
    if (shouldBeClosed) {
      if (onModalClose) {
        onModalClose();
      }
    } else {
      goToPreviousStep();
    }
  }, [configuratorId, currentStepIndex, goToPreviousStep, onModalClose, shouldBeClosed, steps]);
  return isSmallScreen ? null : /* @__PURE__ */ React.createElement(
    SecondaryAction,
    {
      onClick: handleSecondaryAction,
      label: getLabel(shouldBeClosed ? "common.actions.close" : "common.actions.previous")
    }
  );
}
export {
  SecondaryActionContainer
};
//# sourceMappingURL=SecondaryActionContainer.js.map
